export default __webpack_public_path__ + "./image/08e3cd4250cd7b719a3f723e12be949d.png";